import { createContext as e, useCallback as t, useContext as n, useEffect as r, useMemo as i, useRef as a, useState as o } from "react";
import { jsx as s } from "react/jsx-runtime";
//#region src/AuthContext.ts
var c = e(null), l = "platform_auth_", u = {
	ACCESS_TOKEN: `${l}access_token`,
	REFRESH_TOKEN: `${l}refresh_token`,
	TOKEN_EXPIRY: `${l}token_expiry`
};
function d(e) {
	try {
		localStorage.setItem(u.ACCESS_TOKEN, e.accessToken), localStorage.setItem(u.REFRESH_TOKEN, e.refreshToken), e.expiresAt && localStorage.setItem(u.TOKEN_EXPIRY, String(e.expiresAt));
	} catch {
		console.warn("[auth-sdk] Unable to store tokens in localStorage");
	}
}
function f() {
	try {
		let e = localStorage.getItem(u.ACCESS_TOKEN), t = localStorage.getItem(u.REFRESH_TOKEN), n = localStorage.getItem(u.TOKEN_EXPIRY);
		return !e || !t ? null : {
			accessToken: e,
			refreshToken: t,
			expiresAt: n ? Number(n) : void 0
		};
	} catch {
		return null;
	}
}
function p() {
	try {
		return localStorage.getItem(u.ACCESS_TOKEN);
	} catch {
		return null;
	}
}
function m() {
	try {
		return localStorage.getItem(u.REFRESH_TOKEN);
	} catch {
		return null;
	}
}
function h() {
	try {
		let e = localStorage.getItem(u.TOKEN_EXPIRY);
		return e ? Number(e) : null;
	} catch {
		return null;
	}
}
function g() {
	try {
		localStorage.removeItem(u.ACCESS_TOKEN), localStorage.removeItem(u.REFRESH_TOKEN), localStorage.removeItem(u.TOKEN_EXPIRY);
	} catch {}
}
function _() {
	let e = h();
	return !e || Math.floor(Date.now() / 1e3) >= e;
}
function v() {
	let e = h();
	if (!e) return 0;
	let t = Math.floor(Date.now() / 1e3);
	return Math.max(0, e - t);
}
var y = u, b = 300;
function x(e) {
	let { identityCenterUrl: t, onTokensRefreshed: n, onRefreshFailure: r } = e, i = null, a = null;
	async function o(e) {
		try {
			let i = await fetch(`${t}/auth/refresh/`, {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({ refresh_token: e })
			});
			if (!i.ok) return g(), r?.(), null;
			let a = await i.json(), o = S(a.access_token);
			return d({
				accessToken: a.access_token,
				refreshToken: a.refresh_token,
				expiresAt: o
			}), n?.(a.access_token, a.refresh_token), c(), a.access_token;
		} catch {
			return null;
		}
	}
	function s() {
		if (a) return a;
		let e = f();
		return e?.refreshToken ? (a = o(e.refreshToken).finally(() => {
			a = null;
		}), a) : (r?.(), Promise.resolve(null));
	}
	function c() {
		l();
		let e = v();
		if (e <= 0) return;
		let t = Math.max(0, e - b);
		if (t < 10) {
			s();
			return;
		}
		i = setTimeout(() => {
			s();
		}, t * 1e3);
	}
	function l() {
		i &&= (clearTimeout(i), null);
	}
	function u() {
		return a !== null;
	}
	function p() {
		l(), a = null;
	}
	return {
		refreshTokens: s,
		scheduleProactiveRefresh: c,
		cancelProactiveRefresh: l,
		isRefreshing: u,
		destroy: p
	};
}
function S(e) {
	try {
		let t = e.split(".")[1];
		if (!t) return;
		let n = t.replace(/-/g, "+").replace(/_/g, "/"), r = decodeURIComponent(atob(n).split("").map((e) => "%" + ("00" + e.charCodeAt(0).toString(16)).slice(-2)).join(""));
		return JSON.parse(r).exp;
	} catch {
		return;
	}
}
//#endregion
//#region src/pkce.ts
function C() {
	let e = /* @__PURE__ */ new Uint8Array(64);
	return crypto.getRandomValues(e), E(e);
}
function w() {
	let e = /* @__PURE__ */ new Uint8Array(32);
	return crypto.getRandomValues(e), E(e);
}
async function T(e) {
	let t = new TextEncoder().encode(e), n = await crypto.subtle.digest("SHA-256", t);
	return E(new Uint8Array(n));
}
function E(e) {
	let t = Array.from(e, (e) => String.fromCharCode(e)).join("");
	return btoa(t).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}
//#endregion
//#region src/oauth.ts
var D = "platform_auth_pkce", O = "platform_auth_state";
function k(e) {
	sessionStorage.setItem(D, JSON.stringify(e)), sessionStorage.setItem(O, e.state);
}
function A() {
	try {
		let e = sessionStorage.getItem(D);
		return e ? JSON.parse(e) : null;
	} catch {
		return null;
	}
}
function j() {
	sessionStorage.removeItem(D), sessionStorage.removeItem(O);
}
async function M(e) {
	let t = C(), n = await T(t), r = w();
	k({
		codeVerifier: t,
		state: r
	});
	let i = new URLSearchParams({
		response_type: "code",
		client_id: e.clientId,
		redirect_uri: e.redirectUri,
		code_challenge: n,
		code_challenge_method: "S256",
		state: r,
		scope: e.scope
	});
	window.location.href = `${e.identityCenterUrl}/login?${i.toString()}`;
}
async function N(e) {
	let t = C(), n = await T(t), r = w();
	k({
		codeVerifier: t,
		state: r
	});
	let i = new URLSearchParams({
		response_type: "code",
		client_id: e.clientId,
		redirect_uri: e.redirectUri,
		code_challenge: n,
		code_challenge_method: "S256",
		state: r,
		scope: e.scope
	});
	return {
		url: `${e.identityCenterUrl}/login?${i.toString()}`,
		state: r,
		codeVerifier: t
	};
}
async function P(e) {
	let t = new URLSearchParams(window.location.search), n = t.get("code"), r = t.get("state");
	if (!n || !r) return null;
	let i = A();
	if (!i) throw Error("PKCE data not found. Login flow may have been interrupted.");
	if (r !== i.state) throw j(), Error("State mismatch. Possible CSRF attack or expired session.");
	let a = await F(e, n, i.codeVerifier);
	return j(), a;
}
async function F(e, t, n) {
	let r = await fetch(`${e.identityCenterUrl}/auth/token/`, {
		method: "POST",
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify({
			grant_type: "authorization_code",
			code: t,
			redirect_uri: e.redirectUri,
			code_verifier: n,
			client_id: e.clientId
		})
	});
	if (!r.ok) {
		let e = await r.text();
		throw Error(`Token exchange failed (${r.status}): ${e}`);
	}
	return await r.json();
}
function I() {
	let e = new URLSearchParams(window.location.search);
	return e.has("code") && e.has("state");
}
//#endregion
//#region src/AuthProvider.tsx
function L(e) {
	try {
		let t = e.split(".")[1];
		if (!t) return null;
		let n = t.replace(/-/g, "+").replace(/_/g, "/"), r = decodeURIComponent(atob(n).split("").map((e) => "%" + ("00" + e.charCodeAt(0).toString(16)).slice(-2)).join(""));
		return JSON.parse(r);
	} catch {
		return null;
	}
}
function R(e) {
	return {
		id: e.user_id ?? e.sub ?? "",
		email: e.email ?? "",
		firstName: e.first_name ?? "",
		lastName: e.last_name ?? "",
		role: e.role ?? "",
		orgId: e.org_id ?? "",
		schemaName: e.schema_name ?? "",
		permissions: e.permissions ?? [],
		featureFlags: e.feature_flags ?? {}
	};
}
function z({ config: e, children: n }) {
	let [l, u] = o({
		isAuthenticated: !1,
		isLoading: !0,
		accessToken: null,
		refreshToken: null,
		user: null
	}), [m, h] = o(null), _ = a(null);
	r(() => {
		let t = x({
			identityCenterUrl: e.identityCenterUrl,
			onTokensRefreshed: (e, t) => {
				let n = L(e), r = n ? R(n) : null;
				u({
					isAuthenticated: !0,
					isLoading: !1,
					accessToken: e,
					refreshToken: t,
					user: r
				}), h(r);
			},
			onRefreshFailure: () => {
				g(), u({
					isAuthenticated: !1,
					isLoading: !1,
					accessToken: null,
					refreshToken: null,
					user: null
				}), h(null);
			}
		});
		return _.current = t, () => {
			t.destroy();
		};
	}, [e.identityCenterUrl]), r(() => {
		let e = f();
		if (e) {
			let t = L(e.accessToken);
			if (t) {
				let n = t.exp, r = Math.floor(Date.now() / 1e3);
				if (n && n > r) {
					let n = R(t);
					u({
						isAuthenticated: !0,
						isLoading: !1,
						accessToken: e.accessToken,
						refreshToken: e.refreshToken,
						user: n
					}), h(n), _.current?.scheduleProactiveRefresh();
					return;
				}
			}
			g();
		}
		u((e) => ({
			...e,
			isLoading: !1
		}));
	}, []);
	let v = a(!1);
	r(() => {
		v.current || I() && (v.current = !0, (async () => {
			try {
				let t = await P(e);
				if (t) {
					let { access_token: e, refresh_token: n } = t, r = L(e), i = r?.exp;
					d({
						accessToken: e,
						refreshToken: n,
						expiresAt: i
					});
					let a = null;
					r && (a = R(r), h(a)), u({
						isAuthenticated: !0,
						isLoading: !1,
						accessToken: e,
						refreshToken: n,
						user: a
					}), _.current?.scheduleProactiveRefresh(), window.history.replaceState({}, document.title, window.location.pathname);
				}
			} catch (e) {
				console.error("OAuth callback failed:", e), g(), u({
					isAuthenticated: !1,
					isLoading: !1,
					accessToken: null,
					refreshToken: null,
					user: null
				});
			}
		})());
	}, [e]);
	let y = t(() => {
		M(e);
	}, [e]), b = t(async () => {
		let { refreshToken: t } = l;
		if (_.current?.cancelProactiveRefresh(), t) try {
			await fetch(`${e.identityCenterUrl}/auth/logout/`, {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({ refresh_token: t })
			});
		} catch {}
		g(), u({
			isAuthenticated: !1,
			isLoading: !1,
			accessToken: null,
			refreshToken: null,
			user: null
		}), h(null);
		let n = e.postLogoutRedirectUri ?? `${e.identityCenterUrl}/login`;
		window.location.href = n;
	}, [
		l,
		e.identityCenterUrl,
		e.postLogoutRedirectUri
	]), S = t(async () => {
		let e = p();
		if (!e) return null;
		let t = L(e);
		if (t) {
			let n = t.exp, r = Math.floor(Date.now() / 1e3);
			if (n && n > r + 60) return e;
		}
		let n = _.current;
		return n ? await n.refreshTokens() ?? e : e;
	}, []), C = t((e) => m?.featureFlags[e] === !0, [m]), w = t((e) => m?.permissions.includes(e) === !0, [m]), T = t((e) => m ? (Array.isArray(e) ? e : [e]).includes(m.role) : !1, [m]), E = t((e) => m?.featureFlags[`${e}_enabled`] === !0, [m]), D = i(() => ({
		authState: l,
		user: m,
		login: y,
		logout: b,
		getAccessToken: S,
		hasFeatureFlag: C,
		hasPermission: w,
		hasRole: T,
		isSubscribedTo: E
	}), [
		l,
		m,
		y,
		b,
		S,
		C,
		w,
		T,
		E
	]);
	return /* @__PURE__ */ s(c.Provider, {
		value: D,
		children: n
	});
}
//#endregion
//#region src/hooks/useAuth.ts
function B() {
	let e = n(c);
	if (!e) throw Error("useAuth must be used within an AuthProvider");
	return {
		login: e.login,
		logout: e.logout,
		getAccessToken: e.getAccessToken,
		authState: e.authState,
		isAuthenticated: e.authState.isAuthenticated,
		isLoading: e.authState.isLoading
	};
}
//#endregion
//#region src/hooks/useUser.ts
function V() {
	let e = n(c);
	if (!e) throw Error("useUser must be used within an AuthProvider");
	let t = e.user;
	return {
		user: t,
		id: t?.id ?? null,
		email: t?.email ?? null,
		name: t ? `${t.firstName} ${t.lastName}`.trim() : null,
		role: t?.role ?? null,
		orgId: t?.orgId ?? null,
		schemaName: t?.schemaName ?? null
	};
}
//#endregion
//#region src/hooks/usePermissions.ts
function H() {
	let e = n(c);
	if (!e) throw Error("usePermissions must be used within an AuthProvider");
	return {
		hasFeature: e.hasFeatureFlag,
		hasFeatureFlag: e.hasFeatureFlag,
		hasPermission: e.hasPermission,
		hasRole: e.hasRole,
		isSubscribedTo: e.isSubscribedTo,
		permissions: e.user?.permissions ?? [],
		featureFlags: e.user?.featureFlags ?? {},
		role: e.user?.role ?? null
	};
}
//#endregion
//#region src/createAuthInterceptor.ts
function U(e, t) {
	let { identityCenterUrl: n, onAuthFailure: r, onTokensRefreshed: i } = t, a = t.getAccessToken, o = x({
		identityCenterUrl: n,
		onTokensRefreshed: i,
		onRefreshFailure: r
	}), s = [], c = !1;
	function l(t) {
		s.forEach(({ resolve: n, reject: r, config: i }) => {
			t ? (i.headers = i.headers ?? {}, i.headers.Authorization = `Bearer ${t}`, n(e(i))) : r(/* @__PURE__ */ Error("Authentication failed"));
		}), s = [];
	}
	let u = e.interceptors.request.use(async (e) => {
		let t;
		return t = a ? await a() : p(), t && (e.headers = e.headers ?? {}, e.headers.Authorization = `Bearer ${t}`), e;
	}, (e) => Promise.reject(e)), d = e.interceptors.response.use((e) => e, async (t) => {
		let n = t.config;
		if (t.response?.status !== 401 || !n || n._retry) return Promise.reject(t);
		if (c) return new Promise((e, t) => {
			s.push({
				resolve: e,
				reject: t,
				config: n
			});
		});
		n._retry = !0, c = !0;
		try {
			let i = await o.refreshTokens();
			return i ? (n.headers = n.headers ?? {}, n.headers.Authorization = `Bearer ${i}`, l(i), e(n)) : (l(null), r?.(), Promise.reject(t));
		} catch (e) {
			return l(null), r?.(), Promise.reject(e);
		} finally {
			c = !1;
		}
	});
	return { destroy: () => {
		e.interceptors.request.eject(u), e.interceptors.response.eject(d), o.destroy();
	} };
}
//#endregion
export { c as AuthContext, z as AuthProvider, y as TOKEN_STORAGE_KEYS, N as buildLoginUrl, g as clearTokens, U as createAuthInterceptor, x as createTokenRefreshService, T as generateCodeChallenge, C as generateCodeVerifier, w as generateState, p as getAccessToken, m as getRefreshToken, v as getSecondsUntilExpiry, f as getStoredTokens, P as handleCallback, M as initiateLogin, I as isOAuthCallback, _ as isTokenExpired, d as storeTokens, B as useAuth, H as usePermissions, V as useUser };
